@if(isBrowser()) {
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">Preis</span>
        <div class="tmp-section-body">
            @if(showPrice()) {
                <app-doubleslider1 [minValue]="minPricePerPerson()" [maxValue]="maxPricePerPerson()" (output)="dblpricechange($event)" [step]="50">
                </app-doubleslider1>
            }            
        </div>
    </div>
}
